"use strict";

var React = require('react');

var PropTypes = require('prop-types');

var Shipment = require('../../../shipping/Shipment');

function CustomerShippingAddress(_ref) {
  var shipment = _ref.shipment;
  var lastname = shipment.lastname,
      firstname = shipment.firstname,
      address1 = shipment.address1,
      address2 = shipment.address2,
      zip = shipment.zip,
      country = shipment.country,
      city = shipment.city,
      state = shipment.state;
  return /*#__PURE__*/React.createElement("span", null, firstname, " ", lastname, /*#__PURE__*/React.createElement("br", null), address1, /*#__PURE__*/React.createElement("br", null), address2 ? /*#__PURE__*/React.createElement(React.Fragment, null, address2, /*#__PURE__*/React.createElement("br", null)) : null, city, ", ", state, " ", zip, /*#__PURE__*/React.createElement("br", null), country);
}

CustomerShippingAddress.propTypes = {
  shipment: PropTypes.instanceOf(Shipment).isRequired
};
module.exports = CustomerShippingAddress;